<template>

	<div class="bookingtable-component">
		<table class="table table-striped table-light table-hover">
			<thead class="thead-dark">
				<tr>
					<td>{{ $t('booking.checkInTable.tableheader.arrivalday') }}</td>
					<td>{{ $t('booking.checkInTable.tableheader.departureday') }}</td>
					<td>{{ $t('booking.checkInTable.tableheader.bookingtype') }}</td>
					<td>{{ $t('booking.checkInTable.tableheader.gender') }}</td>
					<td>{{ $t('booking.checkInTable.tableheader.firstname') }}</td>
					<td>{{ $t('booking.checkInTable.tableheader.lastname') }}</td>
					<td>{{ $t('booking.checkInTable.tableheader.birthday') }}</td>
					<td>{{ $t('booking.checkInTable.tableheader.company') }}</td>
					<td>{{ $t('booking.checkInTable.tableheader.nationality') }}</td>
					<td>{{ $t('booking.checkInTable.tableheader.streetandnumber') }}</td>
					<td>{{ $t('booking.checkInTable.tableheader.zip') }}</td>
					<td>{{ $t('booking.checkInTable.tableheader.city') }}</td>
					<td>{{ $t('booking.checkInTable.tableheader.country') }}</td>

        	<td>{{ $t('booking.checkInTable.tableheader.licenseplate') }}</td>
					<td>{{ $t('booking.checkInTable.tableheader.mobilephone') }}</td>
					<td>{{ $t('booking.checkInTable.tableheader.emailaddress') }}</td>

					<td>{{ $t('booking.checkInTable.tableheader.roomnumber') }}</td>
					<td>{{ $t('booking.checkInTable.tableheader.roomcategory') }}</td>

					<td>{{ $t('booking.checkInTable.tableheader.keyboycode') }}</td>
					<td>{{ $t('booking.checkInTable.tableheader.creditcard') }}</td>
					<td>{{ $t('booking.checkInTable.tableheader.signature') }}</td>

					<td>&nbsp;</td>
				</tr>
			</thead>
			<tbody>
        <tr v-for="(checkin, k) in this.tableDatas">
          <td>{{ checkin.arrivalDay }}</td>
          <td>{{ checkin.departureDay }}</td>
          <td v-if="checkin.bookingType">{{ checkin.bookingType == 'business' ? 'Geschäftlich' : 'Urlaub' }}</td>
          <td v-else>?</td>
          <td>{{ getGender(checkin.gender) }}</td>
          <td>{{ checkin.firstname }}</td>
          <td>{{ checkin.lastname }}</td>
          <td>{{ checkin.birthday }}</td>
          <td>{{ checkin.company }}</td>
          <td>{{ checkin.nationality }}</td>

          <td>{{ checkin.street }} {{ checkin.streetnumber }}</td>
          <td>{{ checkin.zip }}</td>
          <td>{{ checkin.city }}</td>
          <td>{{ checkin.country }}</td>

          <td>{{ checkin.licenseplate }}</td>
          <td>{{ checkin.mobilephone }}</td>
          <td>{{ checkin.emailaddress }}</td>
          <td>{{ checkin.roomNumber }}</td>
          <td>{{ checkin.roomCategory}} - {{ checkin.roomPrice }} €</td>
          <td>{{ checkin.keyBoyCode }}</td>
          <td v-if="checkin.creditCardNumber" class="modal-element"><a data-toggle="modal" :data-target="getCCTarget(checkin.id,true)">Info</a></td>
          <td v-else>Keine Daten</td>
          <td class="modal-element"><a data-toggle="modal" :data-target="getTarget(checkin.id,true)"><img class="signature-image" :src="getImage(checkin.signature)" /></a></td>
        </tr>
			</tbody>
			<tfoot>
				<tr>
        <td></td>
				</tr>
			</tfoot>
		</table>
    <div class="text-center">
      <button @click.prevent="removeAllCheckIns()">Alle Daten löschen (VORSICHT !!!)</button>
    </div>

    <div v-for="(checkin, k) in this.tableDatas" :id="getTarget(checkin.id)" class="modal fade" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ checkin.firstname }} {{ checkin.lastname }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <img class="signature-image-big" :src="getImage(checkin.signature)" />
          </div>
        </div>
      </div>
    </div>

    <div v-for="(checkin, k) in this.tableDatas" :id="getCCTarget(checkin.id)" class="modal fade" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ checkin.firstname }} {{ checkin.lastname }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <span v-for="(ccData,j) in getCCData(checkin.creditCardNumber, checkin.creditCardSecurityCode)">
              {{ $t(j) }}: {{ ccData }}<br />
            </span>
          </div>
        </div>
      </div>
    </div>

	</div>
</template>


<script>

	import axios from 'axios'
	import Stringify from 'vue-stringify'
  import SimpleCrypto from "simple-crypto-js";
  import { mapState } from 'vuex';
	// import DatePicker from 'vuejs-datepicker'
	// import moment from 'moment'

	export default {
		props: [],
		data: function () {
			return {
        tableDatas: ""
			}
		},

    computed: {
			...mapState('settings', ['config']),
    },

    created: function() {
      this.getAllCheckIns();
    },

    methods: {
        getGender(genderId) {
            var returnValue = '';
            returnValue = genderId == 1 ? 'Frau' : genderId == 2 ? 'Herr' : '-';
            return returnValue;
        },

        getImage(imageCode) {
          return imageCode;
        },

        getTarget(targetId, addIDSymbol = false) {
          let returnValue = addIDSymbol ? '#target-' + targetId : 'target-' + targetId;
          return returnValue;
        },

        getCCTarget(targetId, addIDSymbol = false) {
          let returnValue = addIDSymbol ? '#cc-target-' + targetId : 'cc-target-' + targetId;
          return returnValue;
        },

        getCCData(number,code) {
          var cCData = null;
          if(number && code) {
            try {
              var simpleCrypto = new SimpleCrypto(code);
              cCData = simpleCrypto.decrypt(number);
            } catch( e ) {
              console.log('Could not decrypt CC');
            }
          }
          if (!cCData) return {ccBrand:'', ccNumber:'', ccExpiry:'', cardCvc:''};

          if (typeof cCData == 'string') {
            return JSON.parse(cCData);
          }
          return cCData;
        },

        getAllCheckIns() {
          let self = this;
          axios({
            method: 'post',
            url: this.config.apiUrl + 'getAllCheckins',
            withCredentials: true
          }).then(function(response) {
            if(response.data.status == 'OK') {

              //TODO: Remove console.log() function after testing !!!
              // console.log(response.data);
              self.tableDatas = response.data.returnValue;
            } else {
              self.tableDatas = false;
            }
          });
        },
        removeAllCheckIns() {
          let self = this;
          var question = confirm('Sollen alle Daten unwideruflich gelöscht werden (Daten können dannach nicht mehr wiederhergestellt werden!');
          if(question) {
            axios({
              method: 'post',
              url: this.config.apiUrl + 'removeAllCheckIns',
              withCredentials: true
            }).then(function(response) {
              self.getAllCheckIns();
            });
          }
        }
    },
    components: {
			SimpleCrypto
		}
  }
</script>

<style scoped lang="scss">

  .modal-title {
    background-image: none;
    background-color: #000;
  }

  .modal-body {
    color: #000;
  }

  .modal-element {
    cursor: pointer;
  }

  .signature-image {
    width: 150px;
  }

  .signature-image-big {
    width: 100%;
    height: auto;
  }
</style>
